import React, { useContext, useState } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { assign } from 'xstate';
import { cloneDeep } from 'lodash';
import { IntlShape } from 'react-intl';

import { SendContext } from '../../SendContext';
import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';
import { theme as evoachDefaultTheme } from '../../theme/theme';
import { EvoachButton } from '../Button';

export interface RadioButtonComponent extends BaseComponent {
  type: 'radioButton';
  props: RadioButtonProps;
}
export interface RadioButtonProps {
  radioTexts: string[];
  buttonText: string;
  keyTexts: string[];
  saveResultTo: string;
  keyNumbers?: number[];
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  radioTexts,
  buttonText,
  keyTexts,
  saveResultTo,
  keyNumbers = [],
}) => {
  const { send } = useContext(SendContext);
  const [keyIndex, setKeyIndex] = useState<number>(0);
  const radioButtons = keyTexts.map((currentKeyText, index) => (
    <FormControlLabel
      control={
        <Radio
          onChange={() => setKeyIndex(index)}
          style={{ color: evoachDefaultTheme.palette.secondary.main }}
        />
      }
      label={radioTexts[index]}
      value={'radiobutton' + index}
      key={currentKeyText + '_' + index}
    />
  ));

  return (
    <div>
      <RadioGroup defaultValue="radiobutton0">{radioButtons}</RadioGroup>
      <EvoachButton
        onClick={() => {
          send({
            type: 'writeToContext',
            payload: { [saveResultTo]: radioTexts[keyIndex] },
          });
          send({
            type: 'writeToContext',
            payload: {
              [saveResultTo + '_NUM']:
                keyNumbers !== undefined &&
                keyNumbers !== null &&
                Array.isArray(keyNumbers) &&
                keyNumbers.length > 0
                  ? keyNumbers[keyIndex]
                  : keyIndex,
            },
          });
          send({
            type: keyTexts[keyIndex],
          });
        }}
      >
        {buttonText}
      </EvoachButton>
    </div>
  );
};

export const renderRadioButtonAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );

    const payload = actionMetadata.action.payload;
    const keyTexts = payload.keyTexts;

    // keyTexts contain the translations keys of the buttonTexts

    newContext.widgetData.push({
      type: 'radioButton',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        radioTexts: payload.radioTexts.map((radioTextId: string) =>
          translateWithFallback(intl, radioTextId)
        ),
        buttonText: translateWithFallback(intl, payload.buttonText),
        keyTexts:
          keyTexts &&
          Array.isArray(keyTexts) &&
          keyTexts.length === payload.radioTexts.length
            ? keyTexts
            : payload.radioTexts,
        saveResultTo: payload.saveResultTo,
        keyNumbers: payload.keyNumbers,
      },
    });
    return newContext;
  });
};
